"use strict";

// Import Swiper from 'swiper' (if you are using the Swiper library in regular JS, include Swiper through a CDN or import it directly)

// Utility Functions
function findOneElement(context, selector) {
    return context.querySelector(selector);
  }

  function initSection(selector, callback) {
    document.querySelectorAll(selector).forEach(callback);
  }

  function makeEventNamespace() {
    return {
      addDelegatedEventListener(context, selector, event, handler) {
        context.addEventListener(event, (e) => {
          if (e.target.matches(selector)) {
            handler(e.target, e);
          }
        });
      }
    };
  }

// Initialize the section with the `.js-pdp-testimonials-section` class
initSection(".js-pdp-testimonials-section", (section) => {
    // Find the swiper element
    const swiperElement = findOneElement(section, ".js-pdp-testimonial-swiper");
    const namespace = makeEventNamespace();

    // If the swiper element is not found, return unload with null
    if (swiperElement === null) return { unload: null };

    // Initialize the Swiper instance
    const swiper = new Swiper(swiperElement, {
        // Use Swiper.Autoplay from the global Swiper object
        autoplay: {
            delay: 5000,
        },
        init: false,
        direction: "horizontal",
        slidesPerView: 1,
        spaceBetween: 20,
        speed: 500,
        loop: true,
        navigation: {
            nextEl: ".swiper-button-prev",
            prevEl: ".swiper-button-next"
        },
        breakpoints: {
            768: { slidesPerView: 3, spaceBetween: 10 },
            1920: { slidesPerView: 4 }
        }
    });
    

    // Add event listener for the slideshow arrows
    namespace.addDelegatedEventListener(section, ".js-slideshow-arrow", "click", (target) => {
        const action = target.getAttribute("data-action");
        const swiperAction = action === "prev" ? "slidePrev" : "slideNext";
        swiper[swiperAction]();
    });

    // Add event listener for slideshow dots
    namespace.addDelegatedEventListener(section, ".js-slideshow-dot", "change", (target) => {
        const nextSlideIndex = parseInt(target.getAttribute("data-slide-index") || "0", 10);
        if (!Number.isNaN(nextSlideIndex)) {
            swiper.slideToLoop(nextSlideIndex);
        }
    });

    // Event listener to highlight the active pagination dot
    swiper.on("realIndexChange", (sw) => {
        const element = findOneElement(section, `.js-slideshow-dot[data-slide-index="${sw.realIndex}"]`);
        if (element instanceof HTMLInputElement) element.checked = true;
    });

    // Initialize the swiper instance
    swiper.init();

    // Return the unload function
    return {
        unload: () => {
            swiper.destroy();
        }
    };
});
